import React, { FC } from 'react';
import styled from 'styled-components';
import { colors } from 'src/config/colors';
import CategorySoftSkillsIcon from 'src/assets/icons/CategorySoftSkillsIcon';
import { useDispatch, useSelector } from 'react-redux';
import { courseListingSelectedSpeakersSelector } from 'src/state/courseListing/courseListingSelectors';
import { courseListingActions } from 'src/state/courseListing/courseListingActions';
import { StyleProps } from 'src/lib/styleProps';
import {
  CourseListingFilter,
  CourseListingFilterCheckbox,
  CourseListingFilterItem,
  CourseListingFilterList,
  CourseListingFilterTitle,
} from 'src/public/components/course-listing/CourseListingFilter';
import { speakerFullName } from 'src/common/services/speaker';
import { useSpeakersFiltersQuery } from 'src/common/hooks/speaker/useSpeakersFiltersQuery';

const StyledCategorySoftSkillsIcon = styled(CategorySoftSkillsIcon)`
  .second-color {
    color: ${colors.red};
  }
`;

export const CourseListingSpeakerFilter: FC<StyleProps> = ({ className, style }) => {
  const dispatch = useDispatch();
  const selectedSpeakers = useSelector(courseListingSelectedSpeakersSelector);
  const { data: speakers } = useSpeakersFiltersQuery();

  return (
    <CourseListingFilter className={className} style={style}>
      <CourseListingFilterTitle>
        <StyledCategorySoftSkillsIcon size={18} />
        Trener
      </CourseListingFilterTitle>

      <CourseListingFilterList>
        {speakers?.result?.map((speaker) => (
          <CourseListingFilterItem active={selectedSpeakers[speaker.id]} key={speaker.id}>
            <CourseListingFilterCheckbox
              label={speakerFullName(speaker)}
              onChange={() => dispatch(courseListingActions.toggleSpeaker(speaker.id))}
              value={selectedSpeakers[speaker.id]}
            />
          </CourseListingFilterItem>
        ))}
      </CourseListingFilterList>
    </CourseListingFilter>
  );
};
